import React from "react";
import "./AccountFields.scss";

export const InputField = ({ label, id, type, required = false, handleInputChange, error }) => (
    <div className={`account-page__input-container floating-input ${error ? 'has-error' : ''}`}>
        <input
            type={type}
            id={id}
            name={id}
            className={`account-page__input form-field w-full`}
            placeholder={" "}
            required={required}
            onChange={handleInputChange}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${id}-error` : undefined}
            autoComplete="off"
        />
        {label && <label htmlFor={id}>{label}</label>}
        {error && (
            <div 
                id={`${id}-error`}
                className="mt-1 text-sm text-red-500 error-message" 
                role="alert"
                aria-live="polite"
            >
                {error}
            </div>
        )}
    </div>
);
